import { FC } from "react";
import NewBadge from "./NewBadge";

export type WebinarProps = {
  ID: string;
  Title: string;
  IsNew: boolean;
  ProductTime: string;
  Price: string;
  ProductCredits: number;
  DeliveryFormatName?: string;
  StartDateString: string;
  FieldOfStudyName?: string;
  onWebinarClick?: () => void;
  onAddToCart?: () => void;
};

const WebinarSlot: FC<WebinarProps> = ({
  Title,
  IsNew,
  ProductTime,
  Price,
  ProductCredits,
  onWebinarClick,
  onAddToCart,
}) => {
  return (
    <div>
      {/* Gray line */}
      <div className="tw-bg-[#EBEDF0] tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-1 tw-text-sm">
        <span>{ProductTime}</span>
        <span>{ProductCredits} Credits</span>
      </div>

      <div className="tw-mt-3 tw-px-3">
        <h5
          onClick={onWebinarClick}
          className="tw-block tw-text-tr-dark-blue tw-font-medium tw-leading-tight tw-cursor-pointer"
        >
          {Title}
          {IsNew && <NewBadge size="small" />}
        </h5>

        <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
          <span className="tw-text-tr-black tw-font-medium">{Price}</span>
          <button onClick={onAddToCart}>
            <img
              className="tw-w-6 tw-h-6"
              src="/Mktg/images/tsg/svg/add-to-cart-dark.svg"
              alt="Add to cart"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebinarSlot;
